import Stories from "../../Home/Section/Stories";
import Launch from "../../Home/Section/Launch";
import emailjs from "emailjs-com";
import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [statusMessage, setStatusMessage] = useState("");

  const validate = () => {
    let tempErrors = { ...errors };
    tempErrors.name = formData.name ? "" : "Name is required.";
    tempErrors.phone = formData.phone ? "" : "Phone is required.";
    tempErrors.email = formData.email ? "" : "Email is required.";
    tempErrors.email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(formData.email)
      ? ""
      : "Email is not valid.";
    tempErrors.message = formData.message ? "" : "Message is required.";
    setErrors(tempErrors);

    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      emailjs
        .send(
          "service_z0um1va", // Replace with your EmailJS service ID
          "template_50rbb3m", // Replace with your EmailJS template ID
          formData,
          "V1aB1269bMwqFKFwd" // Replace with your EmailJS user ID
        )
        .then(
          (result) => {
            console.log(result.text);
            setStatusMessage("Email successfully sent!");

            // alert("Email successfully sent!");
          },
          (error) => {
            console.log(error.text);
            setStatusMessage("Email successfully sent!");

            // alert("Failed to send email.");
          }
        );

      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
    }
  };

  return (
    <>
      <section className="KycForm ContactForm">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form onSubmit={handleSubmit}>
                <div className="form">
                  <div className="formheading">
                    <h4>Leave a message</h4>
                  </div>
                  <div className="formbody">
                    <div className="row">
                      <div className="col-12">
                        <div className="input-value">
                          <label>Full Name</label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter your name"
                          />
                        </div>
                        {errors.name && (
                          <div class="alert mb-3 w-100 alert-danger">
                            {errors.name}
                          </div>
                        )}
                      </div>
                      <div className="col-12">
                        <div className="input-value">
                          <label>Email address</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.email && (
                          <div class="alert mb-3 w-100 alert-danger">
                            {errors.email}
                          </div>
                        )}
                      </div>
                      <div className="col-12">
                        <div className="input-value">
                          <label>Phone</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.phone && (
                          <div class="alert mb-3 w-100 alert-danger">
                            {errors.phone}
                          </div>
                        )}
                      </div>
                      <div className="col-12">
                        <div className="input-value">
                          <label>Message</label>
                          <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="7"
                            type="text"
                            className="form-control"
                            placeholder="Tell us about the project you wan to launch"
                          />
                        </div>
                        {errors.message && (
                          <div class="alert mb-3 w-100 alert-danger">
                            {errors.message}
                          </div>
                        )}
                        {statusMessage && (
                          <div
                            className={`alert mt-3 w-100 ${
                              statusMessage.includes("successfully")
                                ? "alert-success"
                                : "alert-danger"
                            }`}
                          >
                            {statusMessage}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-button">
                  <button className="submit">
                    <img src="/images/arrow.png" alt="" />
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Stories />
      <Launch />
    </>
  );
};
export default ContactForm;
